import { Reducer } from 'redux'
import { BlockchainAddress } from '~/store/blockchainAddresses/types'
import { BankAccount } from '~/types'
import {
  ACCEPTED_CURRENCY,
  ActionTypes,
  BANK_TRANSFER_NETWORK,
  Blockchain,
  LANDING_PAGE_ACTIONS,
  STRAITSX_LANDING_PAGE_ACTIONS,
  TRANSFER_METHOD,
} from './types'

export type StateFlippers = {
  isArbitrumUIEnabled: boolean
  isAvalancheUIEnabled: boolean
  isBnbsmartUIEnabled: boolean
  isUSDTBEP20UIEnabled: boolean
  isFazzVaForDashboardEnabled: boolean
  isHederaUIEnabled: boolean
  isPolygonUIEnabled: boolean
  isRippleUIEnabled: boolean
  isTravelRuleDepositDeclarationEnabled: boolean
  isTronUIEnabled: boolean
  isUsdcMaticDepositEnabled: boolean
  isUsdcMaticWithdrawalEnabled: boolean
  isUsdtTrc20DepositEnabled: boolean
  isUsdtTrc20WithdrawalEnabled: boolean
  isXsgdArbDepositEnabled: boolean
  isXsgdArbWithdrawalEnabled: boolean
  isXsgdAvaxDepositEnabled: boolean
  isXsgdAvaxWithdrawalEnabled: boolean
  isXsgdErc20DepositEnabled: boolean
  isXsgdErc20WithdrawalEnabled: boolean
  isXsgdHtsDepositEnabled: boolean
  isXsgdHtsWithdrawalEnabled: boolean
  isXsgdMaticDepositEnabled: boolean
  isXsgdMaticWithdrawalEnabled: boolean
  isXsgdXrpDepositEnabled: boolean
  isXsgdXrpWithdrawalEnabled: boolean
  isXsgdZrc2DepositEnabled: boolean
  isXsgdZrc2WithdrawalEnabled: boolean
  isXusdBep20DepositEnabled: boolean
  isXusdBep20WithdrawalEnabled: boolean
  isUsdtBep20DepositEnabled: boolean
  isUsdtBep20WithdrawalEnabled: boolean
}

export type State = StateFlippers & {
  transferMethod: TRANSFER_METHOD | null
  bankTransferNetwork: BANK_TRANSFER_NETWORK | null
  isConfirmOpen: boolean
  selectedBankAccount: BankAccount | null
  selectedCurrency: ACCEPTED_CURRENCY | null
  selectedBlockchain: Blockchain | null
  selectedBlockchainAddress: BlockchainAddress | null
}

// TODO(benedictkhoo): set type after domain stores are merged into common stores
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {}

export const landingPage: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case LANDING_PAGE_ACTIONS.SET_FLIPPERS:
    case STRAITSX_LANDING_PAGE_ACTIONS.SET_FLIPPERS: {
      const flippers: Partial<StateFlippers> = {}

      if (state && action.flippers.size > 0) {
        action.flippers.forEach((value, key) => {
          flippers[key] = value
        })
      }

      return {
        ...state,
        ...flippers,
      }
    }
    default:
      return state
  }
}
